import { render, staticRenderFns } from "./SalesForm.vue?vue&type=template&id=6b634c56"
import script from "./SalesForm.vue?vue&type=script&lang=js"
export * from "./SalesForm.vue?vue&type=script&lang=js"
import style0 from "./SalesForm.vue?vue&type=style&index=0&id=6b634c56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports